<template>
  <div>Тусгай зөвшөөрлийн тайлан</div>
</template>
<script>
export default {};
</script>
